import React from "react";
import Update from "./Update";
import Delete from "./Delete";
import Create from "../Create";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";
import {
  Fade,
  Card,
  Stack,
  Checkbox,
  IconButton,
  CardHeader,
} from "@mui/material";

export default function ParentModel({
  model,
  delay,
  refetch,
  selection,
  acception,
  handleSelectAllClick,
  isAssign,
}) {
  const { id, title, alias, media, children } = model;

  const roles = ["superadmin", "operator"];
  const { userInfo } = useSelector((state) => state.auth);
  const hasRole = hasRequiredRole(roles, userInfo?.roles);

  return (
    <>
      <Fade
        in
        unmountOnExit
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center">
          <Card
            sx={{
              width: "100%",
              position: "relative",
              bgcolor:
                acception > 0 && selection === acception
                  ? "action.selected"
                  : "background.paper",
            }}
          >
            <CardHeader
              sx={{ px: 1, py: 3 }}
              avatar={
                <Checkbox
                  size="small"
                  onChange={handleSelectAllClick}
                  checked={acception > 0 && selection === acception}
                  indeterminate={selection > 0 && selection < acception}
                />
              }
              title={title}
              subheader={alias}
              action={
                <Stack direction="row" columnGap={0.5} alignItems="center">
                  {hasRole && (
                    <>
                      <Update id={id} refetch={refetch} />
                      <Delete id={id} refetch={refetch} />
                      <Create id={id} refetch={refetch} />
                    </>
                  )}
                  <IconButton
                    disabled
                    size="small"
                    sx={{ bgcolor: "action.hover" }}
                    // onClick={() => showChildren(id)}
                  >
                    <KeyboardArrowDownRoundedIcon fontSize="small" />
                  </IconButton>
                </Stack>
              }
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
